import React, { useState } from "react";
import "../../styles/FaqSection/FaqSection.scss";
import { IoAddCircleOutline } from "react-icons/io5";
import { CiCircleMinus } from "react-icons/ci";
import { useTranslation } from "react-i18next";

interface FAQItem {
  question: string;
  answer: string;
}

export const FAQSection: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const { t } = useTranslation();

  const faqs: FAQItem[] = [
    {
      question: t("faq_license_cost_question"),
      answer: t("faq_license_cost_answer"),
    },
    {
      question: t("faq_office_rent_question"),
      answer: t("faq_office_rent_answer"),
    },
    {
      question: t("faq_benefits_question"),
      answer: t("faq_benefits_answer"),
    },
  ];

  const toggleFAQ = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-header">
        <h2>{t("faq_title")}</h2>
        <h1>{t("faq_subtitle")}</h1>
      </div>

      <div className="faq-items">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              <h3>{faq.question}</h3>
              <span className="toggle-icon ">
                {activeIndex !== index ? (
                  <IoAddCircleOutline />
                ) : (
                  <CiCircleMinus color={"#DBA32C"} />
                )}
              </span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};
